import { useState, useEffect, useRef, useCallback, Fragment, useContext } from "react";
import style from "./Invite.module.scss";
import { v4 } from "uuid";
import * as YStyled from "../../Styleds"
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import apiManager from '../../ApiManager';
import AppConfig from '../../AppConfig';
import { addTextToImage } from "../../comm/comm";
import { GameContext } from "../../GameContext";
import SwifeItem from "../../comm/global/components/SwifeItem";
import ImageLoader from "../../comm/global/components/ImageLoader";

const Invite = ({ query, set_prePage, addModalType }) => {
    const [inviteVo, set_inviteVo] = useState(null);
    const [eventVo, set_eventVo] = useState(null);
    const { preProcessEvent } = useContext(GameContext);
    useEffect(() => {
        console.log("query", query);
        apiManager.fetchGet(`event/${query}`, {}, 0).then(res => {
            console.log(res)
            preProcessEvent(res).then(eventVo => {
                set_eventVo(eventVo)
                let selTempInd = getStyleIndex(eventVo)-1;
                const findObj = AppConfig.modeEnum.find(v => v.id === eventVo.events_type);
                const posDetail = AppConfig.InvitePosDetail(selTempInd, eventVo, findObj);
                console.log("selTempInd", selTempInd,posDetail);
                addTextToImage(`./assets/ui/invite${selTempInd+1}.png`, posDetail).then(img1 => {
                    set_inviteVo({ eventVo: eventVo, img1: img1,selTempInd });
                })
            })
        }).catch(err=>{
           console.log(err);
        })
    }, [])
    function getStyleIndex(eventVo) {
        const ind = eventVo.events_invitation_template.split("_")[1];
        if (!ind) {
            return 0;
        }
        else
            return parseInt(ind);
    }
    return (
        <div className={style.app}>
            {eventVo &&
                <div className={style.info}>
                    <div className={style.user}>
                        <ImageLoader style={{ borderRadius: "50%" }} width={"100%"} height={"100%"} src={eventVo.events_created_by_user.user_avatar} />
                        <YStyled.Span size={15}>{eventVo.events_created_by_user.user_name}</YStyled.Span>
                    </div>
                    <YStyled.Span size={15} fontWeight={400}>邀請你加入</YStyled.Span>
                </div>
            }
            {inviteVo &&
                <div className={style.item}>
                    <SwifeItem page1={
                        <YStyled.InviteBg width="100%" img={inviteVo.img1}>
                        </YStyled.InviteBg>
                    }
                        page2={
                            <YStyled.InviteBg width="100%" img={`./assets/ui/invite${inviteVo.selTempInd+1}b.png`}>
                                <YStyled.StyledTextarea  style={{ userSelect: 'none', pointerEvents: 'none' }}  readOnly value={inviteVo.eventVo.events_invitation_message}
                                    marginTop={AppConfig.msgPos[inviteVo.selTempInd].marginTop}
                                    lineHeight={AppConfig.msgPos[inviteVo.selTempInd].lineHeight}
                                    height={AppConfig.msgPos[inviteVo.selTempInd].height}
                                    width={AppConfig.msgPos[inviteVo.selTempInd].width}
                                ></YStyled.StyledTextarea>
                            </YStyled.InviteBg>
                        }
                    ></SwifeItem>
                </div>
            }

            <YStyled.BTN5 className={style.btn}>
                <YStyled.Span size={17} fontWeight={600} onClick={e => {
                    addModalType({
                        cls: "EventDetail", arg: {
                            cb: () => {
                            },
                            vo: inviteVo.eventVo
                        }
                    })
                    set_prePage(null);
                }}>查看</YStyled.Span>
                <ArrowForwardIosIcon />
            </YStyled.BTN5>
        </div>
    );
}

export default Invite;